import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import {
  DEFAULT_REVIEWER_WINDOW,
  parseReviewerWindow,
  type ReviewerWindowKey,
} from "./reviewer-stats-window";

const WINDOW_PARAM = "window";

export const useReviewerWindow = (): [
  ReviewerWindowKey,
  (key: ReviewerWindowKey) => void,
] => {
  const [searchParams, setSearchParams] = useSearchParams();

  const window =
    parseReviewerWindow(searchParams.get(WINDOW_PARAM)) ??
    DEFAULT_REVIEWER_WINDOW;

  const setWindow = useCallback(
    (key: ReviewerWindowKey) => {
      const next = new URLSearchParams(searchParams);
      next.set(WINDOW_PARAM, key);
      setSearchParams(next);
    },
    [searchParams, setSearchParams],
  );

  return [window, setWindow];
};
